import styled from "@emotion/styled";
import { FeatureContainer, systemWidth } from "@kaltura/mediaspace-shared-styled";
import { Typography } from "@kaltura/ds-react-components";
import { ExploreSideBarLayout } from "@kaltura/mediaspace-shared-search";

export const StyledGlobalSearch = styled(FeatureContainer)(({ theme }) => ({
    ...systemWidth({ theme }),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
}));

export const StyledAllContentContainer = styled(ExploreSideBarLayout)(({ theme }) => ({
    flexGrow: 1,
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(3),
    },
}));

export const StyledSearchFormContainer = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "inModal";
        },
    }
)<{ inModal?: boolean }>(({ inModal, theme }) => ({
    marginBottom: inModal ? 0 : theme.spacing(3),
    [theme.breakpoints.down("md")]: {
        marginBottom: 0,
    },
}));

export const StyledContentFiltersContainer = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "inModal";
        },
    }
)<{ inModal?: boolean }>(({ inModal, theme }) => ({
    display: "flex",
    flexDirection: inModal ? "column" : "row",
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
    },
}));

export const StyledFiltersContainer = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "inModal";
        },
    }
)<{ inModal?: boolean }>(({ inModal, theme }) => ({
    width: inModal ? "100%" : 205,
    marginRight: theme.spacing(4),
    flexGrow: 0,
    [theme.breakpoints.down("md")]: {
        width: "100%",
    },
}));

export const StyledResultsContainer = styled("div")({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 0,
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
    marginBottom: 0,
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(3),
    },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(3),
    maxWidth: 800,
}));
